export default "<router-outlet>\r\n    <app-spinner *ngIf=\"loading\"></app-spinner>\r\n</router-outlet>"